import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_one } from "../../lib/v31lib";
import { loginAtom } from '../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

import {
  Box,
  CircularProgress,
  Grid,
} from '@mui/material';

import {
  Footer,
  WhiteSection
} from '../../components/v2/custom';
import {
  DarkGreenButton,
  Page,
  TextButton,
  Typography
} from '../../components/v2/styled';
import { Vennr } from '../../components/v2/styled/Vennr';
import { Birthdate } from '../../components/v2/styled/Birthdate';
import { OtpCode } from '../../components/v2/styled/OtpCode';

import { Meeting } from '../../models/Meeting';
import { User } from '../../models/User';

const { DateTime } = require("luxon");

type Props = {}

export const Av: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const { state } = useLocation();

  const lenis = new Lenis({
    // duration: 2,
  });

  const [vennr, setVennr] = useState<string>('');
  const [birthdate, setBirthdate] = useState<string>('');
  const [otp, setOtp] = useState<string>('');
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [user, setUser] = useState<User>({
    id: undefined,
    auth_token: '',
    email: '',
    gender: 'M'
  });
  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [step, setStep] = useState<number>(0);

  const {
    data: meeting,
    isLoading: meetingLoading,
    // isError: adviceUploadsError,
    isSuccess: meetingSuccess,
    // refetch: adviceUploadsRefetch,
  } = useQuery({
    queryKey: ["nw", (i18n.resolvedLanguage || 'nl'), "meeting"],
    queryFn: () =>
      fetch_one<Meeting>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'meeting',
          fields: [
            'id', 'created_at', 'field_backstage_name', 'name', 'field_intro', 'is_mandatory', 'field_location', 'meeting_day', 'last_day', 'last_day_vote',
            'field_voting_intro', 'field_voting_documents', 'voting_data', 'is_help_visible'
          ]
        },
        undefined
      ),
    // enabled: false,
  });









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      step: number;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        undefined
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);

      setShowOtp(false);
      setShowError(false);
      setError(undefined);

      if (variables.step === 0) { // verification
        if (!!data.custom_result.mfa_status_0_verification) {
          setShowOtp(true);
        } else {
          if (!data.custom_result.message) {
            setUser({
              ...data.custom_result,
              birth_date: DateTime.fromISO(data.custom_result?.birth_date).toFormat("dd/LL/y")
            });
            setStep(1);
            setTimeout(() => {
              // lenis.scrollTo("top");
              window.scrollTo(0, 0);
            }, 200);
          } else {
            setError(data.custom_result.message);
            setShowError(true);
          }
        }
      }

      if (!!data.custom_result.user) {
        setUser({
          ...data.custom_result.user,
          birth_date: DateTime.fromISO(data.custom_result.user?.birth_date).toFormat("dd/LL/y")
        });
      }
    },
  });







  const subBtns = (backStep:number, nextStep:number, disabled:boolean, onClick?: () => void) => {
    return <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
      <Box sx={{
        display: 'block',
        width: '100%',
        maxWidth: {
          xs: '100%',
          lg: '440px'
        },
        marginTop: 2,
        marginRight: 'auto',
        marginLeft: 'auto',
        textAlign: 'right'
      }}>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          textAlign: 'left',
          float: 'left'
        }}>
          <TextButton
            label={t("nw.emission.forgot.cta_back")}
            id="sub_btn"
            // disabled={backStep < 0}
            onClick={() => {
              if (backStep < 0) {
                navigate("/");
              } else {
                setStep(backStep);
                setTimeout(() => {
                  // lenis.scrollTo("top");
                  window.scrollTo(0, 0);
                }, 200);
              }
            }}
            sx={{
              marginBottom: 1,
              color: theme.palette.primary.dark,
              textDecoration: 'underline',
              "&:hover": {
                color: theme.palette.primary.light,
                backgroundColor: 'transparent'
              },
              paddingLeft: 0,
              paddingRight: 0
            }}
          />
        </Box>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          marginLeft: 'auto',
          textAlign: 'right'
        }}>
          <DarkGreenButton
            label={t("nw.register.hero.cta")}
            id="sub_btn"
            sx={{
              marginBottom: 1,
              borderColor: theme.palette.primary.dark,
              "&:hover": {
                borderColor: theme.palette.primary.dark,
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.dark,
              },
              "&.Mui-disabled": {
                color: 'grey',
              },
            }}
            disabled={disabled}
            onClick={() => {
              if (!onClick) {
                setStep(nextStep);
                setTimeout(() => {
                  // lenis.scrollTo("top");
                  window.scrollTo(0, 0);
                }, 200);
              } else {
                onClick();
              }
            }}
          />
        </Box>
      </Box>
    </Grid>
  }






  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);
  useEffect(() => {
    if (!!state?.user) {
      setUser(state?.user);
      setStep(1);
    }
  }, [state?.user]);

  return <Page sx={{paddingTop: '100px', backgroundColor: theme.palette.background.default}}>
    
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 600,
        height:'auto'
      }
    }}>
      <Grid container spacing={1} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 4
      }}>
        {!!meetingLoading && <>
          <Grid item xs={12} sx={{textAlign: 'center'}}>
            <CircularProgress />
          </Grid>
        </>}
        {!meetingLoading && !!meeting?.field_backstage_name && <>
          {/* <Grid item xs={12} sx={{textAlign: 'center', marginBottom: 8}}>
            <Stepper activeStep={step > 10 ? (step - 10) : step} steps={2 + (meeting?.voting_data || []).length} />
          </Grid> */}
          <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography variant="h1" sx={{display: 'inline-block',}}>{meeting?.field_backstage_name}</Typography>
          </Grid>

          {!!showError && <>
            <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
              <Typography variant="subtitle1" html fuck_p_tags sx={{
                display: 'inline-block',
                color: theme.palette.warning.main
              }}>{t(error || '')}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
              <TextButton
                id="back_btn"
                label={t("nw.av.cta_back")}
                onClick={() => {
                  setStep(0);
                  setShowError(false);
                  setStep(0);
                  setTimeout(() => {lenis.scrollTo(0);}, 200);
                }}
                sx={{
                  marginLeft: 1,
                  marginRight: 1,
                  marginTop: 1
                }}
              />
            </Grid>
          </>}
          {!!showSuccess && <>
            <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
              <Typography variant="subtitle1" html fuck_p_tags sx={{
                display: 'inline-block',
                color: theme.palette.primary.light
              }}>{t("nw.av.confirmed")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
              <TextButton
                id="back_btn"
                label={t("nw.av.cta_back")}
                onClick={() => {
                  setStep(0);
                  setShowError(false);
                  setStep(0);
                  setTimeout(() => {lenis.scrollTo(0);}, 200);
                }}
                sx={{
                  marginLeft: 1,
                  marginRight: 1,
                  marginTop: 1
                }}
              />
            </Grid>
          </>}
          {!showError && !showSuccess && <>
            {!user?.av_stuff?.id && step === 0 && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4, marginBottom: 4}}>
              <Typography variant="subtitle1" html fuck_p_tags sx={{
                display: 'inline-block',
              }}>{t("nw.av.subsection_auth")}</Typography>
            </Grid>}

            {step === 0 && <>
              <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
                <Box sx={{
                  display: 'inline-block',
                  width: {
                    xs: '100%',
                    lg: '440px'
                  },
                  textAlign: 'left'
                }}>
                  <Vennr
                    value={vennr || ''}
                    onChange={(v) => {
                      setVennr(v.target.value);
                    }}
                    starred
                    caption={t("nw.register.form.lidnummer")}
                    // placeholder={t("nw.contact.form.placeholder.first_name")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                  <Birthdate
                    value={birthdate || ''}
                    hideError={(birthdate || "_").indexOf("_") > -1}
                    onChange={(v) => {
                      setBirthdate(v.target.value);
                    }}
                    starred
                    caption={t("nw.user_info.birth_date")}
                    // placeholder={t("nw.contact.form.placeholder.first_name")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                  {!!showOtp && <OtpCode
                    value={otp || ''}
                    onChange={(v) => {
                      setOtp(v.target.value);
                    }}
                    starred
                    caption={t("nw.public.otp_code")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />}
                </Box>
              </Grid>
              {subBtns(-1, 1, (!vennr || !birthdate || (!!showOtp && !OtpCode)), () => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'user',
                    class_action: 'custom_api_validate',
                    birthdate: birthdate,
                    vennr: vennr,
                    otp: otp.replace(" ", "").replace("_", ""),
                    av_info: 1
                  },
                  step: 0
                });
              })}
            </>}

            {step === 1 && !user?.av_stuff?.type && <>
              <Grid item xs={12} md={6} sx={{paddingRight: {xs: 0, md: 2}}}>
                <Typography variant="h3" sx={{display: 'block'}}>{t("nw.meetings.notification.titles.invitation").replace(/<[^>]*>?/gm, '')}</Typography>
                <Typography variant="body1" html altLinks>{meeting?.field_intro}</Typography>
              </Grid>
              <Grid item xs={12} md={6} sx={{paddingLeft: {xs: 0, md: 2}}}>
                <Grid item xs={12}>
                  <Typography variant="h3" sx={{display: 'block'}}>{t("nw.meetings.notification.titles.attendance").replace(/<[^>]*>?/gm, '')}</Typography>
                  <Typography variant="body1" html altLinks>{t("nw.meetings.notification.texts.attendance", {attendance: (!!meeting?.is_mandatory ? t("nw.meetings.attendance_yes").replace(/<[^>]*>?/gm, '') : t("nw.meetings.attendance_no").replace(/<[^>]*>?/gm, ''))})}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" html altLinks>{t("nw.meetings.notification.texts.online_voting", {
                    last_voting_day: DateTime.fromISO(meeting?.last_day_vote).setLocale(i18n.resolvedLanguage || 'nl').toLocaleString(DateTime.DATE_HUGE)
                  })}</Typography>
                </Grid>
                <Grid item xs={12}>
                  {DateTime.fromISO(meeting?.last_day_vote).set({hour: 12, minute: 0, second: 0}) >= DateTime.now() && <DarkGreenButton sx={{marginTop: 0, marginBottom: 2}} id="online_vote" label={t("nw.meetings.notification.cta.online_voting").replace(/<[^>]*>?/gm, '')} onClick={(e) => {
                    navigate('/meeting/voting', {state: {user: user, meeting: meeting}}); window.scrollTo(0, 0);
                  }} />}
                  {DateTime.fromISO(meeting?.last_day_vote).set({hour: 12, minute: 0, second: 0}) < DateTime.now() && <Typography sx={{color: theme.palette.warning.main}} variant="h5">{t("nw.meetings.notification.error.after_voting_last_day").replace(/<[^>]*>?/gm, '')}</Typography>}
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" html altLinks>{t("nw.meetings.notification.texts.physical_attendance", {
                    location: meeting?.field_location,
                    last_day: DateTime.fromISO(meeting?.last_day).setLocale(i18n.resolvedLanguage || 'nl').toLocaleString(DateTime.DATE_HUGE),
                    meeting_day: DateTime.fromISO(meeting?.meeting_day).setLocale(i18n.resolvedLanguage || 'nl').toLocaleString(DateTime.DATE_HUGE)
                  })}</Typography>
                </Grid>
                <Grid item xs={12}>
                  {DateTime.fromISO(meeting?.last_day).set({hour: 23, minute: 59, second: 59}) >= DateTime.now() && <DarkGreenButton sx={{marginTop: 0}} id="attendance" label={t("nw.meetings.notification.cta.confirm_physical").replace(/<[^>]*>?/gm, '')} onClick={(e) => {
                    navigate('/meeting/attend', {state: {user: user, meeting: meeting}}); window.scrollTo(0, 0);
                  }} />}
                  {DateTime.fromISO(meeting?.last_day).set({hour: 23, minute: 59, second: 59}) < DateTime.now() && <Typography sx={{color: theme.palette.warning.main}} variant="h5">{t("nw.meetings.notification.error.after_physical_last_day").replace(/<[^>]*>?/gm, '')}</Typography>}
                </Grid>
              </Grid>
            </>}

            {step === 1 && user?.av_stuff?.type === 'physical' && <>
              <Grid item xs={12} md={3} sx={{display: {xs: 'none', md: 'block'}}}></Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" html altLinks>{t("nw.meetings.notification.attending.intro", {meeting_day: DateTime.fromISO(meeting?.meeting_day).setLocale(i18n.resolvedLanguage || 'nl').toLocaleString(DateTime.DATE_HUGE), location: meeting?.field_location})}</Typography>
                <Typography variant="body1" html altLinks>{meeting?.field_intro}</Typography>
                <Typography variant="body1" html altLinks>{t("nw.meetings.notification.attending.outro", {meeting_day: DateTime.fromISO(meeting?.meeting_day).setLocale(i18n.resolvedLanguage || 'nl').toLocaleString(DateTime.DATE_HUGE), location: meeting?.field_location})}</Typography>
              </Grid>
              <Grid item xs={12} md={3} sx={{display: 'flex', justifyContent: 'flex-end', flexDirection: 'column'}}>
                {!!user?.av_stuff?.confirmation && <DarkGreenButton id="physical_download_confirmation" label={t("nw.meetings.notification.cta.physical_download_confirmation").replace(/<[^>]*>?/gm, '')} onClick={(e) => {
                  window.open(user?.av_stuff?.confirmation, "_BLANK");
                }} sx={{alignSelf: 'end'}} />}
              </Grid>
            </>}

            {step === 1 && user?.av_stuff?.type === 'vote' && <>
              <Grid item xs={12} md={3} sx={{display: {xs: 'none', md: 'block'}}}></Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" html altLinks>{t("nw.meetings.notification.online.intro", {meeting_day: DateTime.fromISO(meeting?.meeting_day).setLocale(i18n.resolvedLanguage || 'nl').toLocaleString(DateTime.DATE_HUGE), location: meeting?.field_location})}</Typography>
              </Grid>
              <Grid item xs={12} md={3} sx={{display: {xs: 'none', md: 'block'}}}></Grid>
              <Grid item xs={12} sx={{display: 'flex', justifyContent: 'flex-end', flexDirection: 'column'}}>
                {!!user?.av_stuff?.confirmation && <DarkGreenButton id="physical_download_confirmation" label={t("nw.meetings.notification.cta.online_download_confirmation").replace(/<[^>]*>?/gm, '')} onClick={(e) => {
                  window.open(user?.av_stuff?.confirmation, "_BLANK");
                }} sx={{alignSelf: 'end'}} />}
              </Grid>
            </>}
          </>}
          
        </>}
        {!meetingLoading && !meeting?.field_backstage_name && <>
          <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography variant="body1" sx={{color: theme.palette.warning.main}}>{t("nw.av.error.no_av")}</Typography>
          </Grid>
        </>}
      </Grid>
    </WhiteSection>

    <Footer normalPage />
  </Page>;
}

